// Environment configuration
const ENV = process.env.REACT_APP_ENV || 'uat';

const config = {
  env: ENV,
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api-nonprod.clickpaysolution.com',
  authServiceUrl: process.env.REACT_APP_AUTH_SERVICE_URL || 'https://api-nonprod.clickpaysolution.com',
  paymentServiceUrl: process.env.REACT_APP_PAYMENT_SERVICE_URL || 'https://api-nonprod.clickpaysolution.com',
  merchantServiceUrl: process.env.REACT_APP_MERCHANT_SERVICE_URL || 'https://api-nonprod.clickpaysolution.com',
  transactionServiceUrl: process.env.REACT_APP_TRANSACTION_SERVICE_URL || 'https://api-nonprod.clickpaysolution.com',
  apiGatewayUrl: process.env.REACT_APP_API_GATEWAY_URL || 'https://api-nonprod.clickpaysolution.com',
  testMerchantUrl: process.env.REACT_APP_TEST_MERCHANT_URL || 'http://merchant-ui-nonprod.s3-website.ap-south-1.amazonaws.com',
  
  // Merchant configuration
  merchantApiKey: process.env.REACT_APP_MERCHANT_API_KEY || 'api_key_10_c4bf4347-b104-48',
  paymentGatewayUrl: process.env.REACT_APP_PAYMENT_GATEWAY_URL || 'https://api-nonprod.clickpaysolution.com',
  successUrl: process.env.REACT_APP_SUCCESS_URL || `${window.location.origin}/payment-success`,
  failureUrl: process.env.REACT_APP_FAILURE_URL || `${window.location.origin}/payment-failed`,
  
  // Helper methods
  isProduction: () => ENV === 'production',
  isUAT: () => ENV === 'uat',
  isLocal: () => ENV === 'local',
};

export default config;
